<template>
  <div>
    <div class="dashboard-head-bg"/>
    <div class="dashboard-head-content">
      <DashboardHeader :firstname=firstname :profile-picture-url=profilePictureUrl />
      <div class="dashboard-status">
        <div class="dashboard-status-content">
          <div class="dashboard-status-content-label">
            Dossier éligible
          </div>
          <div class="dashboard-status-content-progress">
            <ve-progress
                :progress="purcentage"
                :size="100"
                color="#CBDB2A"
                emptyThickness="10%"
                line="square"
                thickness="10%"
            >
              <span class="dashboard-status-content-progress-legend">{{ purcentage }}%</span>
            </ve-progress>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-container">
      <div class="dashboard-section" v-if="comments !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Un commentaire a été déposé sur votre espace</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{ comments }}</pre>
          </div>
        </div>
      </div>

      <div class="dashboard-section" v-if="ofVacationDateAsString !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Congés annuels de votre centre de rattachement</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{ ofVacationDateAsString }}</pre>
          </div>
        </div>
      </div>


      <div v-if="ifDeadlinePassed" class="dashboard-section dashboard-section--critical">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title dashboard-section-header-title--critical"><img src="@/assets/img/raster.png">Important</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline_critical.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            Le délai d'accès aux tests a été dépassé. Vous ne pouvez plus y accédez. Veuillez contacter le centre de formation affecté à votre candidature pour redemander un accès aux tests [via Messages].
          </div>
        </div>
      </div>
      <div v-else-if="dayRemaining == null" class="dashboard-section dashboard-section--warning">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title dashboard-section-header-title--warning"><img src="@/assets/img/raster.png">Important</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline_warning.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            Vos tests en ligne ne sont pas encore activés. Veuillez contacter le centre de formation affecté à votre candidature pour activer votre accès aux tests [via Messages].
          </div>
        </div>
      </div>
      <div v-else-if="!ifDayPlusTwo" class="dashboard-section dashboard-section--warning">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title dashboard-section-header-title--warning"><img src="@/assets/img/raster.png">Important</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline_warning.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            Pour valider votre candidature et augmenter vos chances d'inscription, vos tests doivent être réalisés et enregistrés avant le : <span class="dashboard-section-content-bold">{{ textDateLimitTest }}</span>
          </div>
        </div>
      </div>
      <div v-else class="dashboard-section">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Important</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            Félicitation ! Votre candidature est éligible. Vous pouvez accéder aux tests de qualification en ligne jusqu'au : <span class="dashboard-section-content-bold">{{ textDateLimitTest }}</span>
          </div>
        </div>
      </div>

      <CVBase :ifCVbase=ifCVbase></CVBase>

      <div v-if="ifDeadlinePassed" class="form-group" @click="toContact">
        <button class="btn btn-primary btn-block">
          <span>Contacter le centre</span>
        </button>
      </div>
      <div v-else class="form-group" @click="toFile">
        <button class="btn btn-primary btn-block">
          <span>Accéder aux tests</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import DashboardHeader from '@/components/Dashboard/Header.vue'
import CVBase from '@/components/Dashboard/CVBase.vue'

export default {
  name: "DashboardEligibleCandidature",
  components: {
    DashboardHeader,
    CVBase
  },
  props: {
    firstname: String,
    response: String,
    purcentage: Number,
    ifCVbase: Boolean,
    textDateLimitTest: String,
    ifDayPlusTwo: Boolean,
    ifDeadlinePassed: Boolean,
    statut: String,
    dayRemaining: Number,
    comments: String,
    ofVacationDateAsString: String,
    profilePictureUrl: String,
  },
  methods: {
    toFile: function () {
      this.$router.push({name: 'file'});
    },
    toContact: function () {
      this.$router.push({name: 'contact'});
    }
  },
};
</script>
